import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import IconProfileOut from '../../assets/icone/header/iconaProfiloOut.svg';
import iconProfileFill from '../../assets/icone/header/iconaProfiloFill.svg';

const ProfileButton = ({ onClickProfile }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [isProfileActive, setIsProfileActive] = useState(false);

  useEffect(() => {
    // Controlla se l'URL contiene "/profile" e aggiorna lo stato di conseguenza
    if (location.pathname.includes('/profile')) {
      setIsProfileActive(true);
      if (onClickProfile) onClickProfile(); // Notifica al componente padre
    } else {
      setIsProfileActive(false);
    }
  }, [location.pathname, onClickProfile]);

  return (
    <Link
      to="/profile"
      onClick={() => {
        setIsProfileActive(true);
        if (onClickProfile) onClickProfile();
      }} // Imposta l'icona come fillata quando viene cliccata
    >
      <img 
        src={isProfileActive ? iconProfileFill : IconProfileOut} 
        alt="Profile Icon" 
        className="lg:w-6 md:w-4" 
      />
      <span className="sr-only">{t('buttons.profile')}</span> 
    </Link>
  );
}

export default ProfileButton;
